export const routesAdmin = {
  home: {
    url: '/:lang',
    breadcrumbs: {
      pageTitle: 'page_title_home',
      items: [
        {
          text: 'breadcrumbs_home',
          url: '/:lang'
        }
      ]
    }
  },
  customers: {
    url: '/:lang/customers',
    breadcrumbs: {
      pageTitle: 'page_title_customers',
      items: [
        {
          text: 'breadcrumbs_home',
          url: '/:lang'
        },
        {
          text: 'breadcrumbs_customer',
          url: '/:lang/customers'
        }
      ]
    }
  },
  customersNew: {
    url: '/:lang/customers/add-customer',
    breadcrumbs: {
      pageTitle: 'page_title_customer_add',
      items: [
        {
          text: 'breadcrumbs_home',
          url: '/:lang'
        },
        {
          text: 'breadcrumbs_customer',
          url: '/:lang/customers'
        },
        {
          text: 'breadcrumbs_customer_add',
          url: '/:lang/customers/add-customer'
        }
      ]
    }
  },
  customerDetail: {
    url: '/:lang/customers/:id',
    breadcrumbs: {
      pageTitle: 'page_title_customer_detail',
      items: [
        {
          text: 'breadcrumbs_home',
          url: '/:lang'
        },
        {
          text: 'breadcrumbs_customer',
          url: '/:lang/customers'
        },
        {
          text: 'breadcrumbs_customer_detail',
          url: '/:lang/customers/:id'
        }
      ]
    }
  },
  customerAddInvoiceFee: {
    url: '/:lang/customers/:id/add-invoice-fee',
    breadcrumbs: {
      pageTitle: 'page_title_add_invoice_fee',
      items: [
        {
          text: 'breadcrumbs_home',
          url: '/:lang'
        },
        {
          text: 'breadcrumbs_customer',
          url: '/:lang/customers'
        },
        {
          text: 'breadcrumbs_customer_detail',
          url: '/:lang/customers/:id'
        },
        {
          text: 'breadcrumbs_add_invoice_fee',
          url: '/:lang/customers/:id/add-invoice-fee'
        }
      ]
    }
  },
  customerAddSupplierConnection: {
    url: '/:lang/customers/:id/supplier-connection/:supplier',
    breadcrumbs: {
      pageTitle: 'page_title_customer_supplier_connection',
      items: [
        {
          text: 'breadcrumbs_home',
          url: '/:lang'
        },
        {
          text: 'breadcrumbs_customer',
          url: '/:lang/customers'
        },
        {
          text: 'breadcrumbs_customer_detail',
          url: '/:lang/customers/:id'
        },
        {
          text: 'breadcrumbs_customer_supplier_connection',
          url: '/:lang/customers/:id/supplier-connection/:supplier'
        }
      ]
    }
  },
  files: {
    url: '/:lang/files',
    breadcrumbs: {
      pageTitle: 'page_title_files',
      items: [
        {
          text: 'breadcrumbs_home',
          url: '/:lang'
        },
        {
          text: 'breadcrumbs_files',
          url: '/:lang/files'
        },
      ]
    }
  },
  invoices: {
    url: '/:lang/invoices',
    breadcrumbs: {
      pageTitle: 'page_title_invoicing',
      items: [
        {
          text: 'breadcrumbs_home',
          url: '/:lang'
        },
        {
          text: 'breadcrumbs_invoicing',
          url: '/:lang/invoices'
        },
      ]
    }
  },
  invoicingInvoiceFeeManage: {
    url: '/:lang/invoices/add-invoice-fee/:id',
    breadcrumbs: {
      pageTitle: 'page_title_add_invoice_fee',
      items: [
        {
          text: 'breadcrumbs_home',
          url: '/:lang'
        },
        {
          text: 'breadcrumbs_invoicing',
          url: '/:lang/invoices'
        },
        {
          text: 'breadcrumbs_add_invoice_fee',
          url: '/:lang/invoices/add-invoice-fee/:id'
        }
      ]
    }
  },
  invoiceDetails: {
    url: '/:lang/invoices/details/:batch',
    breadcrumbs: {
      pageTitle: 'page_title_invoice_details',
      items: [
        {
          text: 'breadcrumbs_home',
          url: '/:lang'
        },
        {
          text: 'breadcrumbs_invoicing',
          url: '/:lang/invoices'
        },
        {
          text: 'breadcrumbs_invoices_details',
          url: '/:lang/invoices/details/:batch'
        },
      ]
    }
  },
  invoiceDetailsNoId: {
    url: '/:lang/invoices/details',
    breadcrumbs: {
      pageTitle: 'page_title_invoice_details',
      items: [
        {
          text: 'breadcrumbs_home',
          url: '/:lang'
        },
        {
          text: 'breadcrumbs_invoicing',
          url: '/:lang/invoices'
        },
        {
          text: 'breadcrumbs_invoices_details',
          url: '/:lang/invoices/details'
        },
      ]
    }
  },
}


export const routesCustomer = {
  home: {
    url: '/:lang',
    breadcrumbs: {
      pageTitle: 'page_title_home',
      items: [
        {
          text: 'breadcrumbs_home',
          url: '/:lang'
        }
      ]
    }
  },
  supplierInvoices: {
    url: '/:lang/supplier-invoices',
    breadcrumbs: {
      pageTitle: 'page_title_user_view_supplier_invoices',
      items: [
        {
          text: 'breadcrumbs_home',
          url: '/:lang'
        },
        {
          text: 'breadcrumbs_supplier_invoices',
          url: '/:lang/supplier-invoices'
        }
      ]
    }
  },
  stelInvoices: {
    url: '/:lang/stel-invoices',
    breadcrumbs: {
      pageTitle: 'page_title_user_view_stel_invoices',
      items: [
        {
          text: 'breadcrumbs_home',
          url: '/:lang'
        },
        {
          text: 'breadcrumbs_user_view_stel_invoices',
          url: '/:lang/stel-invoices'
        }
      ]
    }
  },
  myInfo: {
    url: '/:lang/my-info',
    breadcrumbs: {
      pageTitle: 'page_title_user_view_my_info',
      items: [
        {
          text: 'breadcrumbs_home',
          url: '/:lang'
        },
        {
          text: 'breadcrumbs_my_info',
          url: '/:lang/my-info'
        },
      ]
    }
  },
  contacts: {
    url: '/:lang/contacts',
    breadcrumbs: {
      pageTitle: 'page_title_user_view_contacts',
      items: [
        {
          text: 'breadcrumbs_home',
          url: '/:lang'
        },
        {
          text: 'breadcrumbs_contacts',
          url: '/:lang/contacts'
        },
      ]
    }
  },
  generalInfo: {
    url: '/:lang/general-info',
    breadcrumbs: {
      pageTitle: 'page_title_user_view_general_info',
      items: [
        {
          text: 'breadcrumbs_home',
          url: '/:lang'
        },
        {
          text: 'breadcrumbs_general_info',
          url: '/:lang/general-info'
        },
      ]
    }
  },
  smartUsage: {
    url: '/:lang/smart-usage',
    breadcrumbs: {
      pageTitle: 'page_title_user_view_smart_usage',
      items: [
        {
          text: 'breadcrumbs_home',
          url: '/:lang'
        },
        {
          text: 'breadcrumbs_smart_usage',
          url: '/:lang/smart-usage'
        },
      ]
    }
  },
  userUsage: {
    url: '/:lang/usage',
    breadcrumbs: {
      pageTitle: 'page_title_user_view_usage',
      items: [
        {
          text: 'breadcrumbs_home',
          url: '/:lang'
        },
        {
          text: 'breadcrumbs_user_usage',
          url: '/:lang/usage'
        },
      ]
    }
  }
}

export default routesCustomer;
